// https://docs.google.com/document/d/188i-anfgM0KabYRqmgZOTwFVXgqLB0N8zQcaHXmcajk/edit
// Schema color
export const primaryColor = '#49356c';
export const primaryColor2 = '#925ee4';
export const lightPrimaryColor = ' #ebdff5';
export const neonPrimaryColor = '#9161e0';
export const midPrimaryColor = '#b068df';

export const lightPurpleColor = '#EEE6FA';
export const lightYellowColor = '#FFFEC0';
export const lightBlueColor = '#DBDCFD';

export const darkYellowColor = '#fff000';

export const textDarkColor = '#535353';
export const textMediumColor = '#bbbbbb';

export const darkPurple = '#251B36';
export const moonGray = '#d2d2d2';
export const midGray = '#ececec';
// Purple
export const purple = '#49356c';
export const lightPurple = ' #eee6fa';
export const neonPurple = '#9001ff';
export const midPurple = '#d5c2f5';
export const deepPurple = '#251b36';
export const fadePurple = '#8672b7';

// grey
export const utraLightGrey = '#f7f6f6';
export const bgLightGrey = '#f1f1f1';
export const bgMidiGrey = '#e2e2e2';
export const bgStrongGrey = '#a1a1a1';
export const bodytextGrey = '#535353';
export const pretextGrey = '#909090';
export const liningGrey = '#bcbcbc';
export const bgWhiteGrey = '#fcfcfc';
export const textGrey = '#5B5A60';
export const bgGrey = '#F2F3F7';

// yellow
export const pikachuYellow = '#fff000'; //  (Highlight Yellow)
export const sunshineYellow = '#fff553';

// green
export const bgGreen = '#099d04';

export const white = '#fff';
export const lightWhite = '#f1f1f1';
export const yellow = '#FEEF01';
export const lightSilver = '#AAAAAA';
export const nearBlack = '#111111';
export const red = '#FF4136';
export const green = '#19A974';
export const textRed = '#ED2747';



// WEBPACK FOOTER //
// ./app/constants/colors.ts